var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoader)?_c('div',{staticStyle:{"text-align":"center","min-height":"200px"}},[_c('div',{staticClass:"loader-override"}),_c('span',[_vm._v("Carregando informações...")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }